// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-stats[data-v-4c044e21]{border-bottom:#e4e4e4;border-top:#e4e4e4;display:table;font-size:1.5em;position:relative;width:100%}.user-stats[data-v-4c044e21]:before{background:#e4e4e4;content:\"\";display:block;height:100%;left:50%;position:absolute;width:1px}.user-stat[data-v-4c044e21]{display:table-cell;height:4em;text-align:center;vertical-align:middle;width:50%}.stat-title .icon[data-v-4c044e21]{color:#ffc107}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
